interface ControlData {
  sensitivity?: number;
  specificity?: number;
  prevalence?: number;
  [key: string]: any;
}

interface AltTextData {
  afp: number;
  atp: number;
}

const updateFunc = (controlData: ControlData): AltTextData => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;

  const h = 1000 - prevalence;
  const d = prevalence;
  const fp = 100 - specificity;
  const tp = sensitivity;
  const fpr = fp / 100;
  const tpr = tp / 100;
  const afp = fpr * h;
  const atp = tpr * d;

  const calculatedData: AltTextData = {
    afp: Math.round(afp),
    atp: Math.round(atp),
  };
  return calculatedData;
};

export default updateFunc;
